'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CLOUDFLARE_QUERY = 'cloudflare:query';

exports.CLOUDFLARE_QUERY = CLOUDFLARE_QUERY;
